import { Component } from '@angular/core';
import {ButtonDirective} from "primeng/button";
import {ActivatedRoute, RouterLink} from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { CommonModule } from '@angular/common';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-access-denied',
  standalone: true,
  templateUrl: './access-denied.component.html',
  imports: [
    CommonModule,
    ButtonDirective,
    RouterLink
  ],
  styleUrl: './access-denied.component.scss'
})
export class AccessDeniedComponent {
  isValidUser = true;

  constructor(private route: ActivatedRoute, private authService: AuthService) {}

  ngOnInit(): void {
    this.isValidUser = this.authService.validUser;
  }

  logout(): void {
    this.authService.logout();
    localStorage.clear();
  }
}
